"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AskTripUpdateInput = exports.NewPassengerInput = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const address_input_1 = require("../../commons/input/address.input");
class NewPassengerInput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], NewPassengerInput.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], NewPassengerInput.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], NewPassengerInput.prototype, "phoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], NewPassengerInput.prototype, "phoneNumberCountry", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], NewPassengerInput.prototype, "email", void 0);
exports.NewPassengerInput = NewPassengerInput;
class AskTripUpdateInput {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(['BERLINE', 'BUSINESS', 'VAN', 'VAO', 'MOTO', 'GREEN', 'TAXI', 'TAXI_VAN', 'TAXI_CONV', 'ACCESS', 'VAN_ACCESS']),
    __metadata("design:type", String)
], AskTripUpdateInput.prototype, "newPanelKey", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], AskTripUpdateInput.prototype, "newDepartureAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], AskTripUpdateInput.prototype, "newComment", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => address_input_1.AddressInput),
    __metadata("design:type", address_input_1.AddressInput)
], AskTripUpdateInput.prototype, "newStartAddress", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => address_input_1.AddressInput),
    __metadata("design:type", address_input_1.AddressInput)
], AskTripUpdateInput.prototype, "newEndAddress", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => address_input_1.AddressInput),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], AskTripUpdateInput.prototype, "newSteps", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => NewPassengerInput),
    __metadata("design:type", NewPassengerInput)
], AskTripUpdateInput.prototype, "newPassenger", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => NewPassengerInput),
    __metadata("design:type", Array)
], AskTripUpdateInput.prototype, "newOtherPassengers", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)()
    //if true, will not realculate price. If false, will recalculate price ONLY if necessary
    ,
    __metadata("design:type", Boolean)
], AskTripUpdateInput.prototype, "withoutPriceRecalculation", void 0);
exports.AskTripUpdateInput = AskTripUpdateInput;
